import React from 'react';

let reqSentIcon = require('../../../img/ic-request-sent.png');

const RequestSentPage = () =>
(
    <div className="section req-sent-pg">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
              <div className="req-sent-box">
                  <img className="center-block img-responsive" src={reqSentIcon} alt=""/>
                  <h1 className="text-center">Your Request Has Been Sent!</h1>
                  <p className="text-center">We will be in touch with you soon</p>
              </div>
          </div>
          <div className="col-md-12 text-center">
              <button type="submit" className="btn-submit-cta">Ok</button>
          </div>
        </div>
      </div>
    </div>
);

export default RequestSentPage ;



// WEBPACK FOOTER //
// src/components/layout/request-sent.js